import { drama } from '../../../../constants/actionTypes';

export default (state = [], { type, replyId }) => {
  switch (type) {
    case drama.DELETE_DRAMA_REPLY:
      return state.filter(id => id !== replyId);

    case drama.DELETE_DRAMA_REPLY_FAILED:
      return [...state, replyId];

    default:
      return state;
  }
};